<template>
  <div class="row" :class="errorClass" v-if="displayField">
    <div class="col-md-4 col-lg-4 col-xl-3">
      <label class="h6 text-md-right">
        <span v-html="label"></span> <br>
        <small class="text-black-50">{{labelSecondary}}</small>
      </label>
    </div>
    <div class="col-md-8 col-lg-8 col-xl-9">
      <div class="form-group clearfix">
        <textarea
          v-model="textContent"
          class="form-control"
          rows="3"
          placeholder="In less than 150 words"
          v-on:keyup="checkWordsRemaining"
          :class="wordCountWarning"
          v-bind=getIsRequired()>
        </textarea>
        <small class="float-right text-black-50" :class="'small-' + wordCountWarning">You have {{wordsRemaining}} words left</small>
      </div>
      <div v-if="errorClass !== ''" class="alert alert-danger mt-1" role="alert">
        {{validationMessage()}}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'label',
    'labelSecondary',
    'isRequired',
    'displayField',
    'errorClass',
    'defaultText'
  ],
  data () {
    return {
      wordsRemaining: 150,
      textContent: this.defaultText || '',
      wordCountWarning: ''
    }
  },
  methods: {
    getIsRequired: function(){
      return this.isRequired === "true" ? {required: 'required'} : ''
    },
    validationMessage: function () {
      if (this.wordsRemaining < this.textContent.length)
        return 'Only 150 words allowed'
      else if (this.textContent.trim() === '')
        return 'Please complete this field'
      else {
        this.$emit('added150WordContent', {label: this.label, content: this.textContent, validated: this.wordsRemaining >= 0 && this.textContent.length > 0, displayField: this.displayField})
        this.errorClass = ''
      }
    },
    checkWordsRemaining: function (event) {
      this.wordsRemaining = 150 - this.textContent.split(' ').length + 1
      if (this.wordsRemaining < 0) {
        this.wordCountWarning = 'word-count-exceeded'
      } else {
        this.wordCountWarning = ''
      }
      this.$emit('added150WordContent', {label: this.label, content: this.textContent, validated: this.wordsRemaining >= 0 && this.textContent.length > 0, displayField: this.displayField})
    }
  }
}
</script>

<style lang="less">
  .word-count-exceeded {
    border-color: red !important;
    background: lightyellow;
  }
  .small-word-count-exceeded {
    color: red !important;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/Field150Word.vue